import React from 'react'

import { HTMLProps } from 'react'
import { cn } from '../../lib/utils'

export type CardImageSize = 'sm' | 'md' | 'lg'

interface CardBaseProps extends HTMLProps<HTMLDivElement> {
  image?: string
  imageSize?: CardImageSize
  imageClass?: string
  contentClass?: string
}

export interface VCardProps extends CardBaseProps {
  dummy?: boolean
}

export const VCard: React.FC<VCardProps> = ({
  image,
  imageSize = 'md',
  children,
  className,
  imageClass,
  contentClass,
  ...rest
}) => {
  const heightMapping: Record<CardImageSize, string> = {
    sm: 'h-1/3',
    md: 'h-1/2',
    lg: 'h-3/5',
  }

  const imageHeightMapping: Record<CardImageSize, string> = {
    sm: 'h-2/5 min-h-[140px]',
    md: 'h-1/2 min-h-[240px]',
    lg: 'h-4/5 min-h-[320px]',
  }

  return (
    <div
      className={cn(
        'flex flex-col items-start justify-start rounded-2xl bg-primary',
        heightMapping[imageSize],
        className,
      )}
      {...rest}
    >
      {image && (
        <div
          className={cn(
            'relative flex bg-cover bg-[center_top] bg-no-repeat w-full overflow-hidden',
            imageHeightMapping[imageSize],
            imageClass,
          )}
          style={{
            backgroundImage: `url(${image})`,
          }}
        ></div>
      )}

      <div className={cn('content p-6 w-full', contentClass)}>{children}</div>
    </div>
  )
}
